// Visit export for the spreadsheet download.
//
// This is deliberately separate from the `fetchVisits` Redux thunk in
// actions/index.js: the download modal must not disturb the visits already
// loaded into the store for the calendar/patients views, so this helper returns
// the data to the caller without dispatching anything.
//
// The endpoint is admin-only on the backend and accepts a wider window than the
// calendar route, which is what lets the "This Year" preset work.

import client from "./client";

/**
 * Fetch visits for the spreadsheet export.
 *
 * @param {string} start        inclusive lower bound, YYYY-MM-DD
 * @param {string} endExclusive exclusive upper bound, YYYY-MM-DD — the chosen
 *                              last day plus one, matching the endpoint's
 *                              `date.end < endISO` windowing.
 * @returns {Promise<Array>} the raw visit documents (CALENDAR_PROJECTION shape).
 */
export function fetchVisitsForExport(start, endExclusive) {
  return client
    .get(`/visits/export/${start}/${endExclusive}`)
    .then(({ data }) => data);
}
